$(document).foundation();

// Scroll
	$(window).scroll(function(){
		var st = $(this).scrollTop();
		if( st >= 10){
			$('#top').addClass('minimized');
		}else{
			$('#top').removeClass('minimized');
		}
	});

// Hide Header on on scroll down
$(document).ready(function () {
  'use strict';
   var c, currentScrollTop = 0,
       navbar = $('header');

   $(window).scroll(function () {
      var a = $(window).scrollTop();
      var b = navbar.height();
     
      currentScrollTop = a;
     
      if (c < currentScrollTop && a > b + b) {
        navbar.addClass("scrollUp");
      } else if (c > currentScrollTop && !(a <= b)) {
        navbar.removeClass("scrollUp");
      }
      c = currentScrollTop;
  });
});

// Hamburger menu
  $(function(){
  $('#nav-icon3').click(function(){
    $(this).toggleClass('open');
    $('#mainNav').toggleClass('open');
  });
});


$(document).ready(function(){
    // use localStorage.removeItem('show'); to unset an item

    var show = localStorage.getItem('show');
    var show2 = localStorage.getItem('show2');
    var show3 = localStorage.getItem('show3');

    if(show === 'true'){
        $('#provekjor').show();
    }
    $("#btn").click(function(event){
        event.preventDefault();
        $('#provekjor').show();
        $('#kontaktoss').hide();
        $('#bestillverksted').hide();
        localStorage.setItem('show', 'true');
        localStorage.setItem('show2', 'false');
        localStorage.setItem('show3', 'false');
    });
    $("#btnHide").click(function(event){
        event.preventDefault();
        $('#provekjor').hide();
        $('#kontaktoss').hide();
        $('#bestillverksted').hide();
        localStorage.setItem('show', 'false');
        localStorage.setItem('show2', 'false');
        localStorage.setItem('show3', 'false');
    });

    // use localStorage.removeItem('show'); to unset an item
    
    if(show2 === 'true'){
        $('#kontaktoss').show();
    }
    $("#btn2").click(function(event){
        event.preventDefault();
        $('#kontaktoss').show();
        $('#provekjor').hide();
        $('#bestillverksted').hide();
        localStorage.setItem('show', 'false');
        localStorage.setItem('show2', 'true');
        localStorage.setItem('show3', 'false');
    });
    $("#btnHide2").click(function(event){
        event.preventDefault();
        $('#kontaktoss').hide();
        $('#provekjor').hide();
        $('#bestillverksted').hide();
        localStorage.setItem('show', 'false');
        localStorage.setItem('show2', 'false');
        localStorage.setItem('show3', 'false');
    });

    // use localStorage.removeItem('show'); to unset an item
    
    if(show3 === 'true'){
        $('#bestillverksted').show();
    }
    $("#btn3").click(function(event){
        event.preventDefault();
        $('#bestillverksted').show();
        $('#provekjor').hide();
        $('#kontaktoss').hide();
        localStorage.setItem('show', 'false');
        localStorage.setItem('show2', 'false');
        localStorage.setItem('show3', 'true');
        
        
    });
    $("#btnHide3").click(function(event){
        event.preventDefault();
        $('#bestillverksted').hide();
        $('#kontaktoss').hide();
        $('#provekjor').hide();
        localStorage.setItem('show', 'false');
        localStorage.setItem('show2', 'false');
        localStorage.setItem('show3', 'false');
    });
});

// SLIDESHOW FUNCTIONS
//  Full høyde
  //$('.flexslider .slides li, .slideshow').css('height', $(window).height())
  //$(window).on("resize", function () {
  //  $('.flexslider .slides li, .slideshow').css('height', $(window).height())
  //});

  //$('.fullHeight').css('min-height', $(window).height())
  //$(window).on("resize", function () {
  //  $('.fullHeight').css('min-height', $(window).height())
  //});

// Slideshow
  $(function(){
    $(".slideshow li, .subPageTop, .imgSwap").each(function(){
        var d = $(this), i = d.find('img').first();
        if(i.length) {
          d.css({
            'background-image' : 'url(' + i.attr('src') + ')'
          });
        i.remove();
      }
    });
  });

// Flexslider
$('.mainSlider .flexslider').flexslider({
  animation: "fade"
});



$(function() {
  // The slider being synced must be initialized first
  $('#carousel').flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    itemWidth: 210,
    itemMargin: 5,
    asNavFor: '#slider'
  });
 
  $('#slider').flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    sync: "#carousel"
  });
});








$(document).scroll(function () {
    var y = $(this).scrollTop();
    if (y > 400) {
        $('.testopen').fadeIn(500);
    } else {
        $('.testopen').fadeOut(500);
    }

});



//$('.resume') .hide()
//$('a[href^="#"]').on('click', function() {
//$('.resume') .hide()
//    var target = $(this).attr('href');

//    $('.resume'+target).slideToggle();

//});



$(document).ready(function() {
    // Configure/customize these variables.
    var showChar = 1000;  // How many characters are shown by default
    var ellipsestext = "";
    var moretext = "Vis mer";
    var lesstext = "Vis mindre";
    

    $('.more').each(function() {
        var content = $(this).html();
 
        if(content.length > showChar) {
 
            var c = content.substr(0, showChar);
            var h = content.substr(showChar, content.length - showChar);
 
            var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink">' + moretext + '</a></span>';
 
            $(this).html(html);
        }
 
    });
 
    $(".morelink").click(function(){
        if($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).html(moretext);
        } else {
            $(this).addClass("less");
            $(this).html(lesstext);
        }
        $(this).parent().prev().toggle();
        $(this).prev().toggle();
        return false;
    });
});



$(document).ready(function(){
    // use localStorage.removeItem('show'); to unset an item

    var show = localStorage.getItem('show4');

    if(show === 'true'){
        $('#testDrive').addClass("open");
        $(".testopen").addClass("hide");
        $(".testopen").removeClass("show");
        $(".testclose").addClass("show");
        $(".testclose").removeClass("hide");
    }

    $("#btn4").click(function(event){
        event.preventDefault();
        $('#testDrive').addClass("open");
        $('#testDrive').removeClass("hide");
        $("body").addClass("fixed");
        $(".testopen").addClass("hide");
        $(".testopen").removeClass("show");
        $(".testclose").addClass("show");
        $(".testclose").removeClass("hide");
        localStorage.setItem('show4', 'true');
    });

    $(".testclose").click(function(event){
        event.preventDefault();
        $('#testDrive').addClass("hide");
        $('#testDrive').removeClass("open");
        $("body").removeClass("fixed");
        $(".testclose").addClass("hide");
        $(".testclose").removeClass("show");
        $(".testopen").addClass("show");
        $(".testopen").removeClass("hide");
        localStorage.setItem('show4', 'false');
    });
});





